export default __webpack_public_path__ + "static/media/Icon_earning.661cb169.svg";